export default "__VITE_ASSET__DkdIBbxC__"